import * as z from "zod";

/** Ids past this cap keep their English text. */
export const MAX_FLOW_ELEMENT_IDS = 1000;

/**
 * One language's display overlay for the given flow elements: element id ->
 * field -> translated text. Unknown languages return an empty overlay.
 */
export const getFlowElementTextOverlay = {
  name: "getFlowElementTextOverlay" as const,
  input: z.object({
    elementIds: z.array(z.string().max(100)).max(MAX_FLOW_ELEMENT_IDS),
    language: z.string().max(35),
  }),
  output: z.object({
    overlay: z.record(z.string(), z.record(z.string(), z.string())),
  }),
};
